import { registerPlugin } from '@capacitor/core';
const FaceMeshDetection = registerPlugin('FaceMeshDetection', {
    web: () => import('./web').then(m => new m.FaceMeshDetectionWeb()),
});
export * from './definitions';
export { FaceMeshDetection };
//# sourceMappingURL=index.js.map